// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

import "bootstrap"

// Custom js files
import "./custom/frontoffice_header"
import "./custom/init_tom_select"
import "./custom/volunteers_swiper"

document.addEventListener("turbo:load", () => {
  document.querySelectorAll(".flash-close").forEach((btn) => {
    btn.addEventListener("click", () => {
      const flash = btn.closest(".flash-message")
      flash.style.opacity = "0"
      flash.style.transform = "translateY(-10px)"

      setTimeout(() => flash.remove(), 1000)
    })
  })
  setTimeout(() => {
    document.querySelectorAll(".flash-message").forEach((flash) => {
      flash.style.opacity = "0"
      flash.style.transform = "translateY(-10px)"

      setTimeout(() => flash.remove(), 1000)
    })
  }, 4000)

})
